import { memoryGridConfig } from '@labrain/engine-staircase';
export const staircaseConfig = {
    ...memoryGridConfig,
    gameSlug: 'memory-matrix',
    // MVP : 24 essais max (< 5 min test live).
    maxTrials: 24,
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
};
function buildVariant(level) {
    if (level <= 10) {
        return { level, gridSide: 4, flashMs: 1500, label: 'Decouverte' };
    }
    if (level <= 20) {
        return { level, gridSide: 5, flashMs: 1200, label: 'Capacite' };
    }
    if (level <= 30) {
        return { level, gridSide: 5, flashMs: 900, label: 'Vitesse encodage' };
    }
    if (level <= 40) {
        return { level, gridSide: 6, flashMs: 700, label: 'Snapshot net' };
    }
    return { level, gridSide: 7, flashMs: 500, label: 'Pattern dense' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
/** Durees non-staircase (fixation, feedback, ITI). */
export const timing = {
    fixationMs: 400,
    feedbackMs: 700,
    itiMs: 700,
};
export const paradigmMeta = {
    slug: 'memory-matrix',
    paradigm: 'Visual Pattern Test (Della Sala et al. 1997)',
    masterMage: 'Ondine (eau-memoire)',
    category: 'eau_memoire',
    goal: 'Memoire visuelle holistique : navigation, scenes, capture instantanee.',
};
//# sourceMappingURL=params.js.map